<script setup lang="ts">
import DetailedJobAttachmentsActionsMenuList from '@/components/menuLists/DetailedJobAttachmentsActionsMenuList.vue';
import * as commonConstants from '@/constants/common';

export interface Props {
  term?: string;
  downloadHref?: string;
  isDeleteFetching?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  term: commonConstants.EM_DASH,
  downloadHref: '',
  isDeleteFetching: false,
});
const emit = defineEmits<{
  deleteAttachment: [event: Event];
}>();

function handleDeleteAttachment(event: Event): void {
  emit('deleteAttachment', event);
}
</script>

<template>
  <div
    :class="$style.detailedJobAttachmentsDescListItem"
    data-testid="detailedJobAttachmentsDescListItem"
  >
    <dt :class="$style.dt">{{ props.term }}</dt>
    <dd :class="$style.dd">
      <v-icon icon="mdi-file-document-outline" :class="$style.icon"></v-icon>
      <slot>{{ commonConstants.EM_DASH }}</slot>
      <DetailedJobAttachmentsActionsMenuList
        :download-href="props.downloadHref"
        :class="$style.menuList"
        :is-delete-fetching="props.isDeleteFetching"
        @delete-click="handleDeleteAttachment"
      />
    </dd>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.detailedJobAttachmentsDescListItem {
  line-height: 1.4;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  padding-left: 50px;
  position: relative;
}
  .dt {
    margin: 2px 0;
    order: 2;
    word-break: break-word;
    width: 50%;
  }
  .dd {
    margin: 2px 0;
    color: colors.$color-text-tertiary;
  }
    .icon {
      background-color: colors.$color-gray-100;
      color: colors.$color-text-primary;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 6px;
    }
    .menuList {
      position: absolute;
      right: 0;
      top: 6px;
    }
</style>
